export default "__VITE_ASSET__CskUdvJw__"